module.exports = __webpack_public_path__ + "img/logo.7f0ca94d.png";